import { useEffect } from "react";
import "./Privacy.css";
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet-async';

const Privacy = ({lng}) => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
 

  const ogLocales = {
    en: 'en_US',
    es: 'es_ES',
    de: 'de_DE',
    fr: 'fr_FR',
    pt: 'pt_BR',
    sr: 'sr_RS'
  };

  return (
     <div className="privacy">

        <Helmet>
          {/* --- TITLE & CANONICAL --- */}
          <title>{t("Privacy Policy")}</title>
          
          {/* Kosa crta na kraju URL-a zbog Nginx rutinga */}
          <link rel="canonical" href={lng !== "en" ? `https://iscodingforyou.com/${lng}/privacy/` : `https://iscodingforyou.com/privacy/`} />
          
          {/* --- DESCRIPTION --- */}
          <meta name="description" content={t("At Is Coding For You, we take your privacy seriously.")}/>
          <meta charSet="utf-8" />

          {/* --- HREFLANG TAGOVI --- */}
          <link rel="alternate" hreflang="en" href="https://iscodingforyou.com/privacy/" />
          <link rel="alternate" hreflang="es" href="https://iscodingforyou.com/es/privacy/" />
          <link rel="alternate" hreflang="de" href="https://iscodingforyou.com/de/privacy/" />
          <link rel="alternate" hreflang="fr" href="https://iscodingforyou.com/fr/privacy/" />
          <link rel="alternate" hreflang="it" href="https://iscodingforyou.com/it/privacy/" />
          <link rel="alternate" hreflang="pl" href="https://iscodingforyou.com/pl/privacy/" />
          <link rel="alternate" hreflang="tr" href="https://iscodingforyou.com/tr/privacy/" />
          <link rel="alternate" hreflang="pt-BR" href="https://iscodingforyou.com/pt/privacy/" />
          <link rel="alternate" hreflang="sr" href="https://iscodingforyou.com/sr/privacy/" />
          <link rel="alternate" hreflang="x-default" href="https://iscodingforyou.com/privacy/" />
          
          {/* --- OPEN GRAPH --- */}
          <meta property="og:title" key="og:title" content={t("Privacy Policy")} />
          <meta property="og:site_name" key="og:site_name" content="IsCodingForYou.com" />
          <meta property="og:url" key="og:url" content={lng !== "en" ? `https://iscodingforyou.com/${lng}/privacy/` : `https://iscodingforyou.com/privacy/`} />
          <meta property="og:type" key="og:type" content="website" />
          <meta property="og:description" key="og:description" content={t("At Is Coding For You, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website.")} />
          
          {/* Dinamički locale */}
          <meta property="og:locale" key="og:locale" content={ogLocales[lng] || 'en_US'} />
          <meta property="og:locale:alternate" content="sr_RS" />
          <meta property="og:locale:alternate" content="de_DE" />
          <meta property="og:locale:alternate" content="en_US" />
          <meta property="og:locale:alternate" content="es_ES" />
          <meta property="og:locale:alternate" content="fr_FR" />
          <meta property="og:locale:alternate" content="pt_BR" />

          {/* --- TWITTER CARD --- */}
          <meta name="twitter:card" content="summary" /> 
          <meta name="twitter:site" content="https://iscodingforyou.com/" />
          <meta name="twitter:title" content={t("Privacy Policy")} />
          <meta name="twitter:description" content={t("At Is Coding For You, we take your privacy seriously.")} />
        </Helmet>
        
        <div className="content-privacy">
        <h1>{t("Privacy Policy")}:</h1>
        <br/>
        <p>
        {t("At Is Coding For You, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website.")}
        </p>

        <h2>
        {t("What information do we collect?")}
        </h2>

        <p>
        {t("We may collect personal information from you when you use our website, including:")}
        </p>

        <ul>
          <li>
          {t("Your name")}
          </li>
          <li>
          {t("Your email address")}
          </li>
          <li>
          {t("Your IP address")}
          </li>
          <li>
          {t("Your location")}
          </li>
          <li>
          {t("Your test results")}
          </li>
        </ul>

        <p>
        {t("We may also collect information about your use of our website, including:")}
        </p>

        <ul>
          <li>
          {t("Your device type")}
          </li>
          <li>
          {t("Your browser type")}
          </li>
          <li>
          {t("Your operating system")}
          </li>
          <li>
          {t("Your internet service provider")}
          </li>
          <li>
          {t("Your clickstream data")}
          </li>
        </ul>

        <h2>
        {t("How do we use your information?")}
        </h2>

        <p>
        {t("We use your personal information to:")}
        </p>

        <ul>
          <li>
          {t("Provide you with our services, including administering the online test and providing you with your results")}
          </li>
          <li>
          {t("Improve our website and services")}
          </li>
          <li>
          {t("Respond to your inquiries and requests")}
          </li>
          <li>
          {t("Communicate with you about our services and promotions")}
          </li>
          <li>
          {t("Comply with legal obligations")}
          </li>
        </ul>

        <p>
        {t("We may also use your information for other purposes that are disclosed to you and to which you consent.")}
        </p>

        <h2>
        {t("Do we share your information?")}
        </h2>

        <p>
        {t("We may share your information with third parties, including:")}
        </p>

        <ul>
          <li>
          {t("Service providers who help us operate our website and provide our services")}
          </li>
          <li>
          {t("Government or regulatory authorities as required by law")}
          </li>
        </ul>

        <p>
        {t("We may also share your information if we believe it is necessary to protect our rights, property, or safety, or the rights, property, or safety of others.")}
        </p>

        <h2>
        {t("How do we protect your information?")}
        </h2>

        <p>
        {t("We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee the absolute security of your information.")}
        </p>

        <h2>
        {t("What are your choices and rights?")}
        </h2>

        <p>
        {t("You have the right to:")}
        </p>

        <ul>
          <li>
          {t("Access and receive a copy of the personal information we hold about you")}
          </li>
          <li>
          {t("Request that we correct or delete any inaccurate or incomplete personal information we hold about you")}
          </li>
          <li>
          {t("Object to the processing of your personal information for certain purposes, including marketing")}
          </li>
          <li>
          {t("Request that we restrict the processing of your personal information in certain circumstances")}
          </li>
          <li>
          {t("Withdraw your consent at any time, if we rely on your consent to process your personal information")}
          </li>
        </ul>

        <p>
        {t("Please note that some of these rights may be subject to limitations or exceptions under applicable law.")}
        </p>

        <h2>
        {t("How can you contact us?")}
        </h2>

        <p>
        {t("If you have any questions or concerns about our Privacy Policy or practices, please contact us at support@iscodingforyou.com.")}
        </p>

        <p>
        {t("Changes to our Privacy Policy")}
        </p>

        <p>
        {t("We may update this Privacy Policy from time to time by posting a new version on our website. We encourage you to review this Privacy Policy periodically to stay informed about our information practices.")}
        </p>

        <p>
        {t("Effective Date: 27.04.2023")}
        </p>

        <p>
        {t("By using our website, you agree to the terms of this Privacy Policy.")}
        </p>
        </div>
 </div>
  );
};

export default Privacy;
